export default __webpack_public_path__ + "static/media/helppage.45eea061.png";